import React from "react";
import Comments from "../../../controllers/Comments";
import Questions from "../../../controllers/Questions";
import Polls from "../../../controllers/Polls";
import { MODULE_COMMENTS, MODULE_QUESTIONS, MODULE_POLLS } from "../Tabs";

const Module = ({ module, moduleRef, keyboardShowHandler }) => {
    const moduleComponents = {
        [MODULE_COMMENTS]: <Comments moduleRef={moduleRef} keyboardShowHandler={keyboardShowHandler} />, 
        [MODULE_QUESTIONS]:  <Questions moduleRef={moduleRef} keyboardShowHandler={keyboardShowHandler} />, 
        [MODULE_POLLS]: <Polls moduleRef={moduleRef} />, 
    }

    if (!moduleComponents[module]) return null;

    return moduleComponents[module];
};

export default Module;
